import React from 'react'
import { useSelector } from 'react-redux'
import {
  getDependentDetailsLoading
} from 'stores/Account/Select'

const initGlanceItem = (item) => ({ Content, adolescent }) => {
  const {
    loading: loadingSelector,
    json: jsonSelector,
    error: errorSelector
  } = item.selectors

  const isLoading = useSelector(loadingSelector)
  const isLoadingDependent = useSelector(getDependentDetailsLoading)
  const error = useSelector(errorSelector)
  const json = useSelector(jsonSelector)

  const render = () => {
    return Content ? (<Content {...item} adolescent={adolescent} loading={isLoadingDependent || isLoading} data={json} error={error} />) : null
  }

  return render()
}

export default initGlanceItem
